import { faClock } from '@fortawesome/pro-thin-svg-icons';

import '../styles/componentStyles/MindfulMinutes.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

import NumberInput from '../components/NumberInput';

function MindfulMinutes(props) {
  const { t } = useTranslation();

  return (
    <>
      <fieldset
        className="mm-line no-padding"
        aria-labelledby="mood-tracker-mindful-minutes-title mood-tracker-mindful-minutes-in"
      >
        <div className="first-col" id="mood-tracker-mindful-minutes-in">
          {t('T207')}
        </div>
        <div className="second-col fs-mask">
          <FontAwesomeIcon icon={faClock} className="icon clock" />
          <NumberInput
            id="inPlat"
            inputName="inPlat"
            type="inline"
            min="0"
            startValue={props.inPlatform}
            readOnly
            disabled
            suffix={t('T070')}
          />
        </div>
      </fieldset>
      <fieldset
        className="mm-line no-padding"
        aria-labelledby="mood-tracker-mindful-minutes-title mood-tracker-mindful-minutes"
      >
        <div className="first-col" id="mood-tracker-mindful-minutes">
          {t('T208')}
        </div>
        <div className="second-col fs-mask">
          <FontAwesomeIcon icon={faClock} className="icon clock" />
          <NumberInput
            id="offPlat"
            inputName="offPlat"
            type="inline"
            min="0"
            startValue={props.offPlatform}
            onSetValue={(value) => props.handleMinutes(value)}
            onBlur={() => {
              if (props.offPlatform === '') props.handleMinutes(0);
            }}
            controlsInfo={t('trackers.mindfulMinutes.select.label')}
            suffix={t('T070')}
          />
        </div>
      </fieldset>
    </>
  );
}
export default MindfulMinutes;
